module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.reward) ? _c('button', {
    class: 'reward ' + _vm.sold,
    on: {
      "click": _vm.select
    }
  }, [(_vm.reward.photo.url) ? _c('div', [_c('img', {
    staticClass: "reward-image",
    attrs: {
      "src": _vm.$server_url + _vm.reward.photo.url,
      "alt": ""
    }
  })]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "sold-out"
  }, [_vm._v(_vm._s(_vm.$t('reward.soldOut')))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm._f("currencySymbol")(_vm.project.currency)) + _vm._s(_vm.reward.price))]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.reward.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.reward.description))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v(_vm._s(_vm.reward.contributions_count) + " " + _vm._s(_vm.$t('reward.contributions')) + " ( " + _vm._s(_vm.$t('reward.left')) + ": " + _vm._s(_vm.rewardLeft) + " )")])]), _vm._v(" "), (_vm.project.crowdfunding) ? _c('p', {
    staticClass: "get"
  }, [_vm._v(_vm._s(_vm.$t("reward.getReward")))]) : _c('p', {
    staticClass: "get"
  }, [_vm._v(_vm._s(_vm.$t("reward.donate")))])]) : _c('button', {
    staticClass: "btn btn-default btn-lg button-wide",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.select
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t("project.show.contributeButton")) + "\n    ")]), _vm._v(" "), (_vm.selected) ? _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.contribute()
      }
    }
  }, [_c('modal', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.shippingModal),
      expression: "!shippingModal"
    }],
    staticClass: "modal-wide",
    attrs: {
      "close": _vm.close
    }
  }, [_c('h3', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v(_vm._s(_vm.$t('reward.contribute')))]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "align-items": "flex-start"
    },
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_c('img', {
    attrs: {
      "src": require("assets/img/przelewy24.png")
    }
  }), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paymentType),
      expression: "paymentType"
    }],
    attrs: {
      "type": "radio",
      "name": "payment-method",
      "id": "payment-przelewy24",
      "value": "P24"
    },
    domProps: {
      "checked": _vm._q(_vm.paymentType, "P24")
    },
    on: {
      "change": function($event) {
        _vm.paymentType = "P24"
      }
    }
  }), _vm._v("\n\t\t\t\t\t\t\t\tPrzelew online\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('p', [_vm._v("od transakcji pobierana jest prowizja ok. 3,9% wartości transakcji + 50 gr")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('label', [_c('img', {
    attrs: {
      "src": require("assets/img/mastercard-visa.png"),
      "alt": "MasterCard, VISA"
    }
  }), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paymentType),
      expression: "paymentType"
    }],
    attrs: {
      "type": "radio",
      "name": "payment-method",
      "id": "payment-credit-card",
      "value": "CB_VISA_MASTERCARD"
    },
    domProps: {
      "checked": _vm._q(_vm.paymentType, "CB_VISA_MASTERCARD")
    },
    on: {
      "change": function($event) {
        _vm.paymentType = "CB_VISA_MASTERCARD"
      }
    }
  }), _vm._v("\n\t\t\t\t\t\t\t\tPłatność kartą MasterCard / VISA\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('p', [_vm._v("od transakcji pobierana jest prowizja ok. 3,9% wartości transakcji + 1 zł")]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.project.currency !== 'PLN') ? _c('div', [_c('label', [_c('img', {
    attrs: {
      "src": require("assets/img/maestro.png"),
      "alt": "Maestro"
    }
  }), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paymentType),
      expression: "paymentType"
    }],
    attrs: {
      "type": "radio",
      "name": "payment-method",
      "id": "payment-maestro",
      "value": "MAESTRO"
    },
    domProps: {
      "checked": _vm._q(_vm.paymentType, "MAESTRO")
    },
    on: {
      "change": function($event) {
        _vm.paymentType = "MAESTRO"
      }
    }
  }), _vm._v("\n                  Płatność kartą Maestro\n                ")]), _vm._v(" "), _c('p', [_vm._v("od transakcji pobierana jest prowizja ok. 3,9% wartości transakcji + 1 zł")])]) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.project.currency !== 'PLN') ? _c('div', [_c('label', [_c('img', {
    attrs: {
      "src": require("assets/img/diners-club.png"),
      "alt": "Diners Club International"
    }
  }), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.paymentType),
      expression: "paymentType"
    }],
    attrs: {
      "type": "radio",
      "name": "payment-method",
      "id": "payment-diners",
      "value": "DINERS"
    },
    domProps: {
      "checked": _vm._q(_vm.paymentType, "DINERS")
    },
    on: {
      "change": function($event) {
        _vm.paymentType = "DINERS"
      }
    }
  }), _vm._v("\n                  Płatność kartą Diners Club International\n                ")]), _vm._v(" "), _c('p', [_vm._v("od transakcji pobierana jest prowizja ok. 3,9% wartości transakcji + 1 zł")]), _vm._v(" "), _c('p', [_vm._v("Płatności są obsługiwane przez:")])]) : _vm._e(), _vm._v(" "), _c('img', {
    staticClass: "sm-100-w",
    attrs: {
      "src": require("assets/img/powered-by-mangopay.png"),
      "alt": "MANGOPAY, Credit Mutuel ARKEA, Payline"
    }
  }), _c('br'), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [(_vm.reward) ? _c('h3', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.reward.title))]) : _c('h3', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('reward.contribute')))]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.reward) ? _c('h5', [_vm._v(_vm._s(_vm.$t('reward.minimumPrice')) + "\n                "), _c('span', [_c('b', [_vm._v(_vm._s(_vm.reward.price) + " " + _vm._s(_vm._f("currencySymbol")(_vm.project.currency)))])]), _vm._v(" "), _c('br'), _c('br'), _vm._v("\n                " + _vm._s(_vm.$t('reward.additionalPrice')) + "\n                "), (_vm.reward) ? _c('span', [_c('b', [_vm._v(_vm._s(_vm.reward.price) + " " + _vm._s(_vm._f("currencySymbol")(_vm.project.currency)))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('alert', {
    attrs: {
      "error": _vm.alert.error,
      "success": _vm.alert.success
    }
  }), _vm._v(" "), _c('h3', [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contribution),
      expression: "contribution"
    }],
    staticStyle: {
      "width": "100%",
      "padding": "15px"
    },
    attrs: {
      "type": "number",
      "placeholder": _vm.$t('price'),
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.contribution)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contribution = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon"
  }, [_c('h4', [_vm._v(_vm._s(_vm.project.currency))])])])]), _vm._v(" "), _c('checkbox', {
    model: {
      value: (_vm.anonymous),
      callback: function($$v) {
        _vm.anonymous = $$v
      },
      expression: "anonymous"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v(_vm._s(_vm.$t('contribution.anonymous')))])]), _vm._v(" "), (!_vm.user.light_kyc_valid) ? _c('div', [_c('h5', {
    staticClass: "mb-20 mt-30"
  }, [_c('strong', [_vm._v("\n                    " + _vm._s(_vm.user.full_name) + "\n                    "), _c('br'), _vm._v("\n                    " + _vm._s(_vm.user.email) + "\n                  ")])]), _vm._v(" "), _c('datepicker', {
    staticClass: "mb-20",
    attrs: {
      "format": "yyyy-MM-dd",
      "typeable": false,
      "language": _vm.datapickerLang,
      "input-class": "form-control",
      "placeholder": _vm.$t('profile.edit.birthday')
    },
    model: {
      value: (_vm.user.birthday),
      callback: function($$v) {
        _vm.$set(_vm.user, "birthday", $$v)
      },
      expression: "user.birthday"
    }
  }), _vm._v(" "), (_vm.countries.length) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.country_id),
      expression: "user.country_id"
    }],
    staticClass: "form-control mb-20",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.user, "country_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('country')))]), _vm._v(" "), _vm._l((_vm.countries), function(country) {
    return _c('option', {
      domProps: {
        "value": country.id
      }
    }, [_vm._v(_vm._s(country.name))])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.countries.length) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.country_of_residence_id),
      expression: "user.country_of_residence_id"
    }],
    staticClass: "form-control mb-20",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.user, "country_of_residence_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('countryOfResidence')))]), _vm._v(" "), _vm._l((_vm.countries), function(country) {
    return _c('option', {
      domProps: {
        "value": country.id
      }
    }, [_vm._v(_vm._s(country.name))])
  })], 2) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pt-5"
  }, [_c('checkbox', {
    model: {
      value: (_vm.domoreConsent),
      callback: function($$v) {
        _vm.domoreConsent = $$v
      },
      expression: "domoreConsent"
    }
  }, [_c('b', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v(_vm._s(_vm.$t('project.verification.acceptRules')))])]), _vm._v(" "), _c('checkbox', {
    model: {
      value: (_vm.mangopayConsent),
      callback: function($$v) {
        _vm.mangopayConsent = $$v
      },
      expression: "mangopayConsent"
    }
  }, [_c('b', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v(_vm._s(_vm.$t('project.verification.acceptMangopayRules')))])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.reward && !_vm.address) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "width": "100px",
      "margin": "5px"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.show_loader || !_vm.KYCprovided
    },
    on: {
      "click": function($event) {
        return _vm.showShippingModal()
      }
    }
  }, [(!_vm.show_loader) ? _c('span', [_vm._v(_vm._s(_vm.$t('reward.shipping')))]) : _vm._e(), _vm._v(" "), _c('clip-loader', {
    attrs: {
      "loading": _vm.show_loader,
      "color": '#fff',
      "size": '15px'
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.reward || _vm.address) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "width": "100px",
      "margin": "5px"
    },
    attrs: {
      "type": "submit",
      "disabled": _vm.show_loader
    }
  }, [(!_vm.show_loader) ? _c('span', [_vm._v(_vm._s(_vm.$t('reward.contribute')))]) : _vm._e(), _vm._v(" "), _c('clip-loader', {
    attrs: {
      "loading": _vm.show_loader,
      "color": '#fff',
      "size": '15px'
    }
  })], 1) : _vm._e()])]), _vm._v(" "), (_vm.shippingModal) ? _c('modal', {
    staticClass: "modal-wide",
    attrs: {
      "close": _vm.close
    }
  }, [_c('h3', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v(_vm._s(_vm.$t('reward.address')))]), _vm._v(" "), _c('div', {
    staticClass: "row",
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('delivery-address', {
    staticClass: "col-xs-12",
    attrs: {
      "countries": _vm.countries
    },
    on: {
      "onChange": _vm.setDeliveryAddress
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    staticStyle: {
      "width": "61px"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.show_loader
    },
    on: {
      "click": _vm.closeShippingModal
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('back')))])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "width": "100px",
      "margin": "5px"
    },
    attrs: {
      "type": "submit",
      "disabled": _vm.show_loader || !_vm.deliveryAddress.id
    }
  }, [(!_vm.show_loader) ? _c('span', [_vm._v(_vm._s(_vm.$t('reward.contribute')))]) : _vm._e(), _vm._v(" "), _c('clip-loader', {
    attrs: {
      "loading": _vm.show_loader,
      "color": '#fff',
      "size": '15px'
    }
  })], 1)])]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.show_login) ? _c('login-modal', {
    attrs: {
      "close": _vm.closeLogin
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c0e196b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reward/Contribute.vue
// module id = 788
// module chunks = 1